import { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import useMountedState from 'react-use/esm/useMountedState';

import { isAlertsContainerMountedState } from '../../../atoms';
import { ALERTS_CONTAINER_ID } from '../../../config';
import { useWindowSize } from 'react-use';

export type AlertsContainerProps = {
	isAttached?: boolean;
};

export const AlertsContainer: React.FC<AlertsContainerProps> = () => {
	const [isAlertsContainerMounted, setIsAlertsContainerMounted] =
		useRecoilState(isAlertsContainerMountedState);
	const mountedState = useMountedState();

	useEffect(() => {
		const mounted = mountedState();

		if (mounted !== isAlertsContainerMounted) {
			setIsAlertsContainerMounted(mountedState);
		}
	}, [mountedState, isAlertsContainerMounted, setIsAlertsContainerMounted]);

	const { width: screenWidth } = useWindowSize();

	return (
		<div
			style={{
				width: '100%',
				position: 'fixed',
				bottom: screenWidth > 992 ? '80px' : '160px',
				left: '50%',
				transform: 'translate(-50%, 0)'
			}}
		>
			<div>
				<div
					id={ALERTS_CONTAINER_ID}
					className="container mx-auto px-2 px-md-0"
				/>
			</div>
		</div>
	);
};
